
import React from 'react';
import { useI18n } from '@/i18n';
import { Moon, Sun, Languages, RefreshCw, Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useUiStore } from '@/stores/ui-store';
import { NotificationCenter } from '@/components/layout/notification-center';

export const Header: React.FC = () => {
  const { t, language, setLanguage } = useI18n();
  const { toggleSidebar } = useUiStore();
  const [isDark, setIsDark] = React.useState(
    document.documentElement.classList.contains('dark')
  );

  const toggleTheme = () => {
    setIsDark(prev => !prev);
    document.documentElement.classList.toggle('dark');
  };

  const toggleLanguage = () => {
    setLanguage(language === 'ar' ? 'en' : 'ar');
  };

  return (
    <header className="h-16 border-b bg-card/80 backdrop-blur-sm sticky top-0 z-10 flex items-center justify-between px-4 md:px-6">
      <div className="flex items-center">
        <Button variant="ghost" size="icon" onClick={toggleSidebar} className="md:hidden mr-2 rtl:ml-2">
          <Menu className="w-5 h-5" />
        </Button>
      </div>

      <div className="flex items-center gap-2">
        <NotificationCenter />
        <Button variant="ghost" size="icon" onClick={toggleLanguage} title={t('settings_language')}>
          <Languages className="w-4 h-4" />
        </Button>
        <Button variant="ghost" size="icon" onClick={toggleTheme} title={t('settings_theme')}>
          {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
        </Button>
      </div>
    </header>
  );
};
